import { useAuth } from '@auth/oauth/AuthProvider';
import { pending, ok } from '@engage/result/pendingResult';

export const useRequiresAuth = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return pending;
  }
  return ok(isAuthenticated);
};
